import React from "react";
import { useBilling } from "../../../../contexts/api/billing";
import type { Prestation, PrestationRequest } from "../../../../api/billing/Billing.typed";

export default function usePrestations() {
  const { listPrestations, createPrestation, updatePrestation, deletePrestation } = useBilling();
  const [prestations, setPrestations] = React.useState<Prestation[]>([]);
  const [loading, setLoading] = React.useState(true);

  const reload = React.useCallback(async () => {
    setLoading(true);
    const data = await listPrestations();
    if (data) setPrestations(data);
    setLoading(false);
  }, [listPrestations]);

  React.useEffect(() => {
    reload();
  }, [reload]);

  const create = React.useCallback(
    async (req: PrestationRequest) => {
      const created = await createPrestation(req);
      if (created) setPrestations((prev) => [...prev, created]);
      return created;
    },
    [createPrestation],
  );

  const update = React.useCallback(
    async (id: number, req: PrestationRequest) => {
      const updated = await updatePrestation(id, req);
      if (updated) setPrestations((prev) => prev.map((p) => (p.ID === id ? updated : p)));
      return updated;
    },
    [updatePrestation],
  );

  const remove = React.useCallback(
    async (id: number) => {
      const ok = await deletePrestation(id);
      if (ok) setPrestations((prev) => prev.filter((p) => p.ID !== id));
    },
    [deletePrestation],
  );

  return { prestations, loading, reload, create, update, remove };
}
